import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=5b38a6a4"
import script from "./Landing.vue?vue&type=script&lang=ts"
export * from "./Landing.vue?vue&type=script&lang=ts"
import style0 from "./Landing.vue?vue&type=style&index=0&id=5b38a6a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports